import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1754313315960,
      error: {
        code: 0,
        label: '',
        message: '',
      },
      object: 'calculatecyclemortgagewithsameperiod',
      success: true,
      data: {
        totalsBeforeCalculation: {
          totalAmount: 158282.42,
          newMonthlyPayment: 898.710171825865,
          interestRepayment: 725.4610916666667,
          principalRepayment: 173.24908015919843,
          finalPayment: 323535.66185731144,
          linkageRepayment: 0,
          maxMonthlyPayment: 898.710171825865,
          returnConversion: 2.044040404849202,
        },
        totalsAfterCalculation: {
          totalAmount: 158282.42,
          newMonthlyPayment: 865.4890044485314,
          interestRepayment: 680.6531920833334,
          principalRepayment: 184.83581236519825,
          finalPayment: 311576.04160147137,
          linkageRepayment: 0,
          maxMonthlyPayment: 865.4890044485314,
          returnConversion: 1.9684816646186691,
        },
      },
    },
    error: {
      response: {
        createdAt: 1701115461239,
        object: 'calculation',
        success: false,
      },
      status: 500,
    },
  },
};

const calculateCycleMortgageWithSamePeriodHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  calculateCycleMortgageWithSamePeriodHandler,
};
